export default __webpack_public_path__ + "static/media/warning--slippery-motorcycles--g1.55df543d.png";